import { app } from '@microsoft/teams-js';
import { useCallback, useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useAppDispatch } from '../../../store/hooks';
import {
    loadDepartureBoardArrivalAirportsFilter,
    loadDepartureBoardDepartureAirportsFilter,
    loadDepartureBoardFlights,
    setCurrentPage,
} from '../../../store/features/departureBoard/departureBoardSlice';
import { loadConfig } from '../../../store/features/config/configSlice';

export const useDepartureBoardPageData = (loadStatus: string) => {
    const dispatch = useAppDispatch();

    const loadFlightsDebounced = useDebouncedCallback(
        useCallback(
            (page?: number) => {
                if (page) {
                    dispatch(setCurrentPage(page));
                }
                dispatch(loadDepartureBoardFlights());
            },
            [dispatch]
        ),
        600
    );

    useEffect(() => {
        dispatch(loadDepartureBoardFlights());
        dispatch(loadDepartureBoardDepartureAirportsFilter());
        dispatch(loadDepartureBoardArrivalAirportsFilter());
        dispatch(loadConfig());
    }, [dispatch]);

    useEffect(() => {
        if (loadStatus === 'idle') {
            app.notifySuccess();
        }
    }, [loadStatus]);

    useEffect(() => {
        return () => {
            loadFlightsDebounced.cancel();
        };
    }, [loadFlightsDebounced]);

    return {
        loadFlightsDebounced,
    };
};
